export default __webpack_public_path__ + "static/media/benefit_2.94044a18.png";